'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Image URL
 * @param  {String} folder assets folder
 * @param  {String} image  image filename
 * @return {String}        CSS url() string
 */
var url = function url(folder) {
  return function (image) {
    return 'url(/images/' + folder + '/' + image + ')';
  };
};

/**
 * Background underline
 * @param  {Object} object color, posX, posY, sizeX, sizeY
 * @return {String}        '0' or linear-gradient
 */
var underlineObject = function underlineObject(_ref) {
  var color = _ref.color,
      _ref$posX = _ref.posX,
      posX = _ref$posX === undefined ? '0' : _ref$posX,
      _ref$posY = _ref.posY,
      posY = _ref$posY === undefined ? '90%' : _ref$posY,
      _ref$sizeX = _ref.sizeX,
      sizeX = _ref$sizeX === undefined ? '100%' : _ref$sizeX,
      _ref$sizeY = _ref.sizeY,
      sizeY = _ref$sizeY === undefined ? '2px' : _ref$sizeY;

  if (!color) {
    return '0';
  }
  var linear = 'linear-gradient(to bottom, transparent 50%, ' + color + ' 50%)';
  var opts = 'no-repeat content-box ' + posX + ' ' + posY + ' / ' + sizeX + ' ' + sizeY;
  return linear + ' ' + opts;
};

var underline = function underline(options) {
  if (typeof options === 'string') {
    return underlineObject({ color: options });
  }
  return underlineObject(options);
};

/**
 * Create arrow
 * @param  {String} arrow 'left' or 'right'
 * @return {Object}        CSS object
 */
var createArrow = function createArrow(_ref2) {
  var _before;

  var arrow = _ref2.arrow;
  return arrow ? {
    position: 'relative',
    float: arrow,
    display: 'flex',
    '::before': (_before = {
      alignSelf: 'center',
      border: '1px solid #fffdd8',
      borderWidth: '1px 1px 0 0',
      content: '""',
      height: '10px'
    }, _defineProperty(_before, arrow, '-1em'), _defineProperty(_before, 'position', 'absolute'), _defineProperty(_before, 'transform', 'rotate(' + (arrow === 'left' ? 225 : 45) + 'deg)'), _defineProperty(_before, 'width', '10px'), _before)
  } : {};
};

/*
 * Export
 */
exports.default = {
  url: url,
  underline: underline,
  createArrow: createArrow
};